import React from 'react';
import { ProductDetail as ProductDetailComponent } from '@/components/products/ProductDetail';

export const ProductDetail: React.FC = () => {
  return <ProductDetailComponent />;
};
